import type { ImagePresentation, Product, Sticker } from '../../types/dontgiftguide';

export enum LevelOneContentType {
  SectionGroup = 'sectionGroup',
  SectionGroupHeader = 'sectionGroupHeader',
  Charity = 'charity',
}

export enum LevelTwoContentType {
  Items = 'items',
  Feature = 'feature',
  Partner = 'partner',
  TopGiftingTips = 'topGiftingTips',
  MostMisGifted = 'mostMisGifted',
}

export enum LevelThreeContentType {
  Heading = 'heading',
  Copy = 'copy',
  LargeTile = 'largeTile',
  WideTile = 'wideTile',
  SmallTile = 'smallTile',
  ExtraSmallTile = 'extraSmallTile',
}

export interface ItemContent {
  contentType: LevelThreeContentType;
  productCode?: number;
  product?: Partial<Product>;
  copy?: string;
  sticker?: Sticker;
}

interface BaseSectionContent {
  contentType: LevelTwoContentType;
}

export interface FeatureSectionContent extends BaseSectionContent {
  copy: string;
  darkCopyColor: boolean;
  backgroundColor?: string;
  imagePresentation: ImagePresentation;
  productCode: number;
  product?: Partial<Product>;
  sticker?: Sticker;
}

export interface ItemsSectionContent extends BaseSectionContent {
  items: ItemContent[];
}

export type MostMisGiftedSectionContent = BaseSectionContent;

export interface PartnerSectionContent extends BaseSectionContent {
  partnerImage: string;
  copy: string;
  darkCopyColor: boolean;
  backgroundColor: string;
  productCode: number;
  product?: Partial<Product>;
}

export type TopGiftingTipsSectionContent = BaseSectionContent;

export type SectionContent =
  | FeatureSectionContent
  | ItemsSectionContent
  | MostMisGiftedSectionContent
  | PartnerSectionContent
  | TopGiftingTipsSectionContent;

export interface HrefsByClient {
  app: string;
  web: string;
}

export interface SectionGroupFooterContent {
  title: string;
  links: {
    href: HrefsByClient;
    text: string;
  }[];
}

interface BaseLevelOneContent {
  contentType: LevelOneContentType;
}

export interface SectionGroupContent extends BaseLevelOneContent {
  title: string;
  darkTitleColor: boolean;
  backgroundColor: string;
  heading: string;
  copy: string;
  categoryHref?: HrefsByClient;
  sections: SectionContent[];
  footer?: SectionGroupFooterContent;
}

export interface SectionGroupHeaderContent extends BaseLevelOneContent {
  heading: string;
  copy: string;
}

export interface DontGiftGuideContent {
  seo: {
    title: string;
    description: string;
  };
  levelOne: (SectionGroupContent | SectionGroupHeaderContent)[];
}
